import ContentLoader from 'react-content-loader'

export const ImageLoader = () => {
  return (
    <ContentLoader
      speed={1}
      foregroundColor="#242b34"
      backgroundColor="#343d4c"
      backgroundOpacity={0.6}
      foregroundOpacity={0.6}
      width="100%"
      height="100%"
    >
      <rect x="0" y="0" rx="16" ry="16" width="100%" height="100%" />
    </ContentLoader>
  )
}

export const TextLoader = () => {
  return (
    <ContentLoader
      speed={1}
      foregroundColor="#242b34"
      backgroundColor="#343d4c"
      backgroundOpacity={0.6}
      foregroundOpacity={0.6}
      width="100%"
      height="100%"
    >
      <rect x="0" y="3" rx="0" ry="0" width="60" height="17" />
      <rect x="0" y="29" rx="0" ry="0" width="100%" height="17" />
    </ContentLoader>
  )
}
